import React from 'react';
import { Link } from 'react-router-dom';

const ArtistPayoutKycPolicy = () => (
  <div className="min-h-screen bg-[#0e0e0e] text-white px-4 py-8">
    <div className="max-w-2xl mx-auto">
      <Link to="/login" className="text-red-500 hover:text-red-400 text-sm mb-6 inline-block">← Back to Login</Link>
      <h1 className="text-2xl font-bold text-red-500 mb-6">Artist Payout &amp; KYC Policy</h1>
      <div className="text-white/80 space-y-4 leading-relaxed text-sm">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <p>Artists on HubTune receive tips from listeners through our payment partners. To keep payouts secure and compliant, we may need to verify the artist&apos;s identity and review tip activity before releasing funds.</p>
        <p>Artists must complete identity verification (Know Your Customer / KYC) before requesting withdrawals. This may include providing basic personal details, government-issued identification, and payout information such as UPI details.</p>
        <p>HubTune processes artist payouts only after internal checks. We may hold funds temporarily for compliance review, fraud prevention, and risk assessment. This helps protect both artists and listeners from misuse of the platform.</p>
        <p>Payout requests are usually processed within 1–5 business days, depending on verification status, transaction volume, and risk review. Processing times may be longer if additional documents or checks are required.</p>
        <p>HubTune reserves the right to delay, limit, or suspend payouts where we suspect fraud, abuse, policy violations, or legal risk, or where required by law or our payment partners.</p>
      </div>
    </div>
  </div>
);

export default ArtistPayoutKycPolicy;

